export interface InreturnCredentials {
  inretrnUrl: string;
  inretrnToken: string;
}

export const getInreturnCredentials = (): InreturnCredentials => {
  let inretrnUrl: string = "";
  let inretrnToken: string = "";

  if (typeof window !== "undefined") {
    switch (true) {
      case window.location.hostname.includes("miss-mary-891303671566"):
        inretrnUrl = "https://returnsportal.inretrn.com/inretrn.js";
        inretrnToken = "OjptaXNzbWFyeQ";
        break;
      case window.location.hostname.includes("staging"):
        inretrnUrl = "https://returnsportal.inretrn.com/inretrn.js";
        inretrnToken = "OjptaXNzbWFyeQ";
        break;
      case window.location.hostname.includes("localhost"):
      case /miss-mary-.+run\.app/.test(window.location.hostname):
        inretrnUrl = "https://uat-returnsportal.inretrn.com/inretrn.js";
        inretrnToken = "OjptaXNzbWFyeQ==";
        break;
      default:
        // All production domains must be used for this url. Without this, the
        // x-ga cookie will not persist as it's SameSite=Lax.
        inretrnUrl = "https://returnsportal.inretrn.com/inretrn.js";
        inretrnToken = "OjptaXNzbWFyeQ";
        break;
    }
  }
  return { inretrnUrl, inretrnToken };
};
